import { ENGINE_CHART_LIST } from "../../components/trendPage/engine/engineList";
import { ENGINE_TYPE } from "../../constants/trendGraph/enginesLine";

export const engineTrendDataProcess = async (data, selectedGraph, position, vessel, startDate, endDate) => {
  if (data?.[1]?.vesselMainEngineData.length <= 0 && data?.[0]?.vesselEngineData.length <= 0) {
    return [];
  } else {
    const chartDetails = ENGINE_CHART_LIST.find(
      (dd) => selectedGraph === dd?.id && position === dd?.position
    );
    let dataList = chartDetails?.dataList;
    if (vessel.MEEngineType === ENGINE_TYPE.STRAIGHT) {
      dataList = dataList?.filter((c) => !c.keyName.startsWith("meExhGasB"));
    }
    const cylinder = vessel.cylinder;
    dataList = dataList?.filter(
      (b) => !b.keyName.startsWith("meExhGas") || b.keyName.match(/\d+/)?.[0] <= cylinder
    );

    const returnedData = await chartDetails
      ?.reducer(
        data?.[1]?.vesselMainEngineData,
        data?.[0]?.vesselEngineData,
        data?.[2]?.gpvtgData,
        startDate, // startDate and endDate is not need but this function is using many place so I don't touch now
        endDate,
        dataList.map((d) => d.keyName)
      )
    return returnedData;
  }
}